<mat-progress-bar mode="indeterminate" [class.animated-hidden]="!showLoadingBar || _print_version" class="loading-bar"></mat-progress-bar>
<div class="wrapper">
  <div *ngIf="!_print_version" class="navbar" [class.navbar-mob-open]="navbarMobileOpen" style="color: black!important;">
    <!-- <div *ngIf="!topMenuLoadingComplete" class="navbar-loading">
        <div class="navbar-left" style="color: black!important;">
            <ul class="menu-container">
                <li class="menu-item"><span>{{'Loading' | translate | async}}</span></li>
                <li class="menu-item"><span>{{'Loading' | translate | async}}</span></li>
                <li class="menu-item"><span>{{'Loading' | translate | async}}</span></li>
            </ul>
        </div>
        <div class="navbar-right"  style="color: black!important;">
            <ul class="menu-container">
                <li class="menu-item"><span>{{'Loading' | translate | async}}</span></li>
                <li class="menu-item"><span>{{'Loading' | translate | async}}</span></li>
            </ul>
        </div>
    </div>  -->
    <div class="navbar-mob-button" (click)="navbarMobileOpen = !navbarMobileOpen" style="color: black;">
      <i *ngIf="topMenuLoadingComplete" class="material-icons">&#xE5D2;</i>
    </div>
    <div [class]="division.DivCssClass" *ngFor="let division of TopMenu?.Divisions">
      <ul [class]="division.UlCssClass">
        <li class="app-logo">
          <a [routerLink]="['/']">
            <img class="app-logo__image" src="/api/Application/DealershipLogo/" />
          </a>
        </li>
        <li [class]="levelOne.LiCssClass" *ngFor="let levelOne of division.levelOneList">
          <a *ngIf="!levelOne.isMenuNotLink  && levelOne.Id != 10" (click)="menuClicked(levelOne.Link.Id,levelOne.Link.Href,levelOne.Link.OpenInNewWindow,1)">{{levelOne.Link.Text | translate | async}}</a>
          <span *ngIf="levelOne.isMenuNotLink && levelOne.Id != 10" (click)="toggleCssMenuExpandedL1(levelOne) ">
            <!-- Is not 7 Means is not Account or Help-->
            {{levelOne.Span.SpanText | translate | async}}
            <i [class]="levelOne.Span.IconCssClass">&#xE313;</i>
          </span>
          <span *ngIf="!levelOne.isMenuNotLink && levelOne.Id == 10">
            <span id="loggedInUser">{{userName}}</span>
            <i></i>
          </span>
          <ul class="sub-menu-container" style="background:#cddbe8">
            <li [class]="levelTwo.LiCssClass" *ngFor="let levelTwo of levelOne.levelTwoList">
              <a *ngIf="!levelTwo.isMenuNotLink" (click)="menuClicked(levelTwo.Link.Id,levelTwo.Link.Href,levelTwo.Link.OpenInNewWindow,2)">{{levelTwo.Link.Text | translate | async}}</a>
              <span *ngIf="levelTwo.isMenuNotLink" (click)="toggleCssMenuExpandedL2(levelTwo)">
                {{levelTwo.Span.SpanText | translate | async}}
                <i [class]="levelTwo.Span.IconCssClass">&#xE313;</i>
              </span>
              <ul *ngIf="levelTwo.isMenuNotLink" class="sub-menu-container">
                <li *ngFor="let levelThree of levelTwo.levelThreeList" [class]="levelThree.LiCssClass">
                  <a (click)="menuClicked(levelThree.Link.Id,levelThree.Link.Href,levelThree.Link.OpenInNewWindow,3)">
                    {{(levelThree.Link.Text || '').trim() | translate | async}}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="page">
    <simple-notifications [options]="options"></simple-notifications>
    <div [ngClass]="getMarginClass()">
      <router-outlet></router-outlet>
      <!--<setup-undercarriage *ngIf="CheckStatus(2,1)"></setup-undercarriage>-->
    </div>
  </div>
</div>